import { useState, lazy, Suspense } from 'react';

import { Box, Tooltip, Typography } from '@mui/material';
import { AnimatePresence } from 'framer-motion';

import FloatingIcon from '@/assets/agents/floating-icon.png';
import { useChatActions } from '@/store/chat/chatStore';
import { useSelectedMeetings } from '@/store/selectedMeetingsStore';

import { ChatBubleNumber } from './ChatStyle';

const LazyChatModal = lazy(() => import('@/components/modals/ChatModal/ChatModal'));

const ChatContainer = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { resetChat } = useChatActions();
  const chatMeetings = useSelectedMeetings();
  const toggleChatWindow = () => {
    setIsChatOpen(prev => !prev);
  };

  const onCloseChat = () => {
    setIsChatOpen(false);
  };

  return (
    <>
      <Tooltip title={`Ask questions about this meeting`} arrow>
        <Box
          onClick={toggleChatWindow}
          sx={{
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            width: '50px',
            height: '50px',
            cursor: 'pointer',
            zIndex: 1
          }}
        >
          <img src={FloatingIcon} alt="Chat" />
          {chatMeetings.length > 1 && !isChatOpen && (
            <ChatBubleNumber>
              <Typography variant="body2" sx={{ fontSize: '12px' }}>
                {chatMeetings.length}
              </Typography>
            </ChatBubleNumber>
          )}
        </Box>
      </Tooltip>
      <AnimatePresence onExitComplete={resetChat}>
        {isChatOpen && (
          <Suspense key="chat-modal">
            <LazyChatModal open={isChatOpen} onClose={onCloseChat} />
          </Suspense>
        )}
      </AnimatePresence>
    </>
  );
};

export default ChatContainer;
